"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageOverduePopup = void 0;
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var il_manage_student_overdue_1 = require("./il-manage-student-overdue");
var material_1 = require("@mui/material");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
function ManageOverduePopup(_a) {
    var _this = this;
    var _b = _a.open, open = _b === void 0 ? false : _b, onClose = _a.onClose, dialogProps = _a.dialogProps, props = __rest(_a, ["open", "onClose", "dialogProps"]);
    var fullScreen = (0, material_1.useMediaQuery)(function (theme) { return theme.breakpoints.down('lg'); });
    var _c = react_1.default.useState(props.selectedAssigment), selectedCourse = _c[0], setSelectedCourse = _c[1];
    var _d = react_1.default.useState(false), submitted = _d[0], setSubmitted = _d[1];
    return (react_1.default.createElement(material_1.Dialog, __assign({ onClose: onClose, open: open, maxWidth: "lg", fullScreen: fullScreen, PaperProps: { sx: { backgroundColor: 'background.default' } } }, dialogProps),
        react_1.default.createElement(material_1.IconButton, { sx: {
                position: 'absolute',
                mt: '0.5rem',
                mr: '1rem',
                top: 0,
                right: 0,
            }, onClick: onClose, "data-testid": "close-icon" },
            react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.X_MARK_ICON, size: enums_1.IconSizeEnum.SMALL })),
        react_1.default.createElement(il_manage_student_overdue_1.ILManageStudentOverdue, __assign({}, props, { submitted: submitted, selectedAssigment: selectedCourse, onReschedule: function (assignment) {
                setSubmitted(false);
                setSelectedCourse(assignment);
                props.onReschedule && props.onReschedule(assignment);
            }, onSubmit: function (formValues) { return __awaiter(_this, void 0, void 0, function () {
                var data, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = props.onSubmit;
                            if (!_a) return [3 /*break*/, 2];
                            return [4 /*yield*/, props.onSubmit(formValues)];
                        case 1:
                            _a = (_b.sent());
                            _b.label = 2;
                        case 2:
                            data = _a;
                            setSelectedCourse(undefined);
                            setSubmitted(true);
                            return [2 /*return*/, data];
                    }
                });
            }); } }))));
}
exports.ManageOverduePopup = ManageOverduePopup;
